import React from 'react';
import UpButton from '../../components/Common/UpButton';
import QuestionIcon from '../../assets/icons/QuestionIcon';
import AnalyticsService from '../../services/analytics';

function HelpText({ prefilled, screen }) {
  const handleContactSupport = () => {
    try {      
      const subject = `Facing issue with Login`;

      // Construct and validate mailto link
      const mailtoLink = `mailto:support@urbanpiper.com?subject=${encodeURIComponent(subject)}`;

      // Open email client
      window.location.href = mailtoLink;
    } catch (error) {
      console.error('Error opening email client:', error);
    }
  };

  return (
    <div className="text-sm flex flex-col justify-center items-center mt-12 md:mt-2">
      <div className="text-up-clr-dark-grey flex items-center">
        <QuestionIcon />
        <span className="ml-2">Can&apos;t access your account?</span>
      </div>
      <div className="flex items-center">
        <span className="text-up-clr-dark-grey">
          Reach out at support@urbanpiper.com
        </span>
      </div>
    </div>
  );
}

export default HelpText;
